import * as firebase from 'firebase'
import { Store } from 'vuex';

export default {
  state: {
    controls: null
  },
  mutations: {
    setControls(state, payload) {
      state.controls = payload
    },
    setControlsP(state, payload) {
      state.controls.play = payload
    },
    setControlsPreview(state, payload) {
      state.controls.preview = payload
    },
    setControlsGenerate(state, payload) {
      //state.controls.generate = payload
    },
    setControlsOpen(state, payload) {
      state.controls.open = payload
    },
  },
  actions: {
    loadControls({ commit }) {
      firebase
        .database()
        .ref('control')
        .on('value', function(snapshot) {

          commit('setControls', snapshot.val())
        });
    },
    setControlsPlay({ commit }, payload) {
      var value = parseInt(payload.index, 10) || 1;
      if (!isNaN(this.getters.getControlsPlay)) {
        //value = this.getters.getControlsPlay + 1;
      }
      firebase
        .database()
        .ref('control')
        .update({ play: value })
        .then(() => {

          commit('setControlsP', value)
        })
    },
    setControlsGenerate({ commit }, payload) {

      console.log("Generating", payload);
      firebase
        .database()
        .ref('command')
        .update({ command: 'generate', generate: payload })
        .then(() => {
          console.log("Generating", payload);
          commit('setControlsGenerate', payload)
        })
    },
    setControlsOpen({ commit }, payload) {

      console.log("Opening", payload);
      firebase
        .database()
        .ref('command')
        .update({ command: 'open', open: payload.id })
        .then(() => {

          commit('setControlsOpen', payload.id)
          firebase
            .database()
            .ref('status')
            .update({ 'schedule': payload.id, starttime: payload.startTime })
            .then(() => {

            })
        })
    },
    setControlsVolume({ commit }, payload) {


      firebase
        .database()
        .ref('command')
        .update({ command: 'volume', volume: payload })
        .then(() => {

        })
    },

    setControlsPreview({ commit }, payload) {
      var value = parseInt(payload.index, 10) || 1;
      firebase
        .database()
        .ref('control')
        .update({ preview: value })
        .then(() => {
          console.log("Updated", value, payload);
          commit('setControlsPreview', value)
        })
    },
    sendCommand({ commit }, payload) {
      var duration = 1000;
      if (payload.paramname == "duration") {
        duration = parseInt(payload.param, 10);
      }
      firebase
        .database()
        .ref('command')
        .set({ command: payload.cmd, duration: duration, id: Math.floor(Math.random() * 100000) })
        .then(() => {
          console.log("Command Sent");
          //commit('setControlsP', value)
        })
    },
    sendMessage({ commit }, payload) {

      firebase
        .database()
        .ref('message')
        .set({ heading: payload.heading, description: payload.description, id: Math.floor(Math.random() * 100000) })
        .then(() => {
          console.log("Message Sent");
          //commit('setControlsP', value)
        })
    }
  },
  getters: {
    getControls(state) {
      return state.controls
    },
    getControlsPlay(state) {
      if (state.controls != null) {
        return state.controls.play
      } else {
        return null
      }

    }
  }
}


// WEBPACK FOOTER //
// ./src/store/control/index.js